import { createSlice } from "@reduxjs/toolkit";
import {
  getAllOrganisation,
  inviteOrganitation,
  updateOrganisationStatus,
  getOrganisationDetails,
  getOrganizationSettingsDetails,
  updateOrganizationSettings,
  getOrganizationManagerDetails,
  updateOrganizationManager,
  getOrganistionList,
} from "store/actions/organizationSlice";

const initialState = {
  isLoading: false,
  loading: true,
  perPage: 50,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  organisations: [],
  organisationsList: [],
  organisationDetails: {},
  gettingDetails: false,
  gettingDetails2: false,
  organizationSettingsDetails: {},
  organizationManagerDetails: {},
};

const organizations = createSlice({
  name: "organisation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllOrganisation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOrganisation.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data, totalCount, totalPages, currentPage } =
          action.payload || {};

        if (success) {
          state.organisations = data || [];
          state.totalCount = totalCount || 0;
          state.totalPages = totalPages || 0;
          state.currentPage = currentPage || 1;
        }
      })
      .addCase(getAllOrganisation.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateOrganisationStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOrganisationStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};

        if (success && data) {
          const id = data._id;
          const status = data.status;
          state.organisations = state.organisations.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateOrganisationStatus.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(inviteOrganitation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(inviteOrganitation.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(inviteOrganitation.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(getOrganisationDetails.pending, (state) => {
        state.gettingDetails = true;
        state.organisationDetails = {};
      })
      .addCase(getOrganisationDetails.fulfilled, (state, action) => {
        state.gettingDetails = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.organisationDetails = data;
        }
      })
      .addCase(getOrganisationDetails.rejected, (state, action) => {
        state.gettingDetails = true;
      });

    builder
      .addCase(getOrganizationSettingsDetails.pending, (state) => {
        state.gettingDetails2 = true;
        state.organizationSettingsDetails = {};
      })
      .addCase(getOrganizationSettingsDetails.fulfilled, (state, action) => {
        state.gettingDetails2 = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.organizationSettingsDetails = data;
        }
      })
      .addCase(getOrganizationSettingsDetails.rejected, (state, action) => {
        state.gettingDetails2 = true;
      });

    builder
      .addCase(updateOrganizationSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOrganizationSettings.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateOrganizationSettings.rejected, (state, action) => {
        state.isLoading = true;
      });

    builder
      .addCase(getOrganizationManagerDetails.pending, (state) => {
        state.gettingDetails2 = true;
        state.organizationManagerDetails = {};
      })
      .addCase(getOrganizationManagerDetails.fulfilled, (state, action) => {
        state.gettingDetails2 = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.organizationManagerDetails = data;
        }
      })
      .addCase(getOrganizationManagerDetails.rejected, (state, action) => {
        state.gettingDetails2 = true;
      });

    builder
      .addCase(updateOrganizationManager.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOrganizationManager.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateOrganizationManager.rejected, (state, action) => {
        state.isLoading = true;
      });
    builder
      .addCase(getOrganistionList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrganistionList.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        const { data } = action.payload || {};
        if (success) {
          state.organisationsList = data;
        }
      })
      .addCase(getOrganistionList.rejected, (state) => {
        state.isLoading = true;
      });
  },
});

export default organizations.reducer;
